import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Checkout } from './Checkout';

/**
 * Anonymous checkout wrapper - renders the main Checkout component in anonymous mode
 * This is used when a guest user clicks "Proceed to Checkout" from a shared draft link
 */
const AnonymousCheckout: React.FC = () => {
  const navigate = useNavigate();
  const [shareToken, setShareToken] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get share token from sessionStorage
    const token = sessionStorage.getItem('shareToken');
    if (!token) {
      // No token found, redirect back to home or show error
      console.error('No share token found for anonymous checkout');
      navigate('/');
      return;
    }
    setShareToken(token);
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return <Checkout isAnonymous={true} shareToken={shareToken} />;
};

export default AnonymousCheckout;
